import React from "react";

const RepositoryComponent = () => {
  return (
    <div>
      <p>
        Paste your schema and then we will generate your schema into readable
        type data structure. This is very useful when you need documentation
        about your endpoint. Swagger allows you to describe the structure of
        your APIs so that machines can read them. The ability of APIs to
        describe their own structure is the root of all awesomeness in Swagger.
      </p>
      <h3>Awesome Team</h3>
      <p>
        <a href="https://github.com/mufti1">Mufti Ismi Rizqi (Backend)</a>
      </p>
      <p>
        <a href="https://github.com/ade1256">Ade Prasetyo (Frontend)</a>
      </p>
      <h3>Repositories</h3>
      <a href="https://github.com/ade1256/jsonToSwagger">
        https://github.com/ade1256/jsonToSwagger (frontend)
      </a>
      <br />
      <a href="https://github.com/mufti1/json-to-swagger">https://github.com/mufti1/json-to-swagger (backend)</a> <br/> <br/>
      <h3>Page Views: </h3>
      <img src="https://hitwebcounter.com/counter/counter.php?page=7195916&style=0030&nbdigits=5&type=ip&initCount=0" title="User Stats" Alt="webcounterwebsite"   border="0" />
    </div>
  );
};

export default RepositoryComponent;
